import React, { useState, useEffect } from 'react';
import { supabase } from '../utils/supabase';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState(''); // 'success' | 'error' | ''
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [validSession, setValidSession] = useState(false);

  useEffect(() => {
  // Check if we already have a recovery session
  supabase.auth.getSession().then(({ data: { session } }) => {
    if (session) setValidSession(true);
  });

  const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
    if (event === 'PASSWORD_RECOVERY' || event === 'SIGNED_IN') {
      setValidSession(true);
    }
  });

  return () => subscription.unsubscribe();
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      setStatus('error');
      setMessage('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirm) {
      setStatus('error');
      setMessage('Passwords do not match.');
      return;
    }
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (error) {
      setStatus('error');
      setMessage(error.message);
    } else {
      setStatus('success');
      setMessage('Password updated! You can now sign in.');
    }
  };

  return (
    <div className="app" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <div className="auth-modal" style={{ position: 'relative', maxWidth: '380px', width: '100%' }}>
        <div className="auth-modal-header">
          <h2 className="auth-title">RESET PASSWORD</h2>
          <div className="title-stripe small" />
          <p className="auth-subtitle">Enter your new password below.</p>
        </div>

        {status === 'success' ? (
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
            <p style={{ fontFamily: 'var(--font-heading)', color: 'var(--gold)', letterSpacing: '2px', fontSize: '13px' }}>
              {message}
            </p>
            <a href="/" className="btn btn-primary" style={{ display: 'block', marginTop: '24px', textDecoration: 'none', textAlign: 'center' }}>
              GO TO HOME
            </a>
          </div>
        ) : !validSession ? (
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
            <p style={{ fontFamily: 'var(--font-heading)', color: 'var(--text-dim)', letterSpacing: '2px', fontSize: '12px' }}>
              WAITING FOR RESET LINK...
            </p>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-dim)', fontSize: '11px', marginTop: '8px' }}>
              Click the link in your email to continue.
            </p>
          </div>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="auth-field">
              <label className="auth-label">NEW PASSWORD</label>
              <input
                className="auth-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Min 6 characters"
                autoFocus
                required
              />
            </div>
            <div className="auth-field">
              <label className="auth-label">CONFIRM PASSWORD</label>
              <input
                className="auth-input"
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Repeat password"
                required
              />
            </div>
            {status === 'error' && (
              <div className="auth-error">{message}</div>
            )}
            <button
              className="btn btn-primary"
              type="submit"
              disabled={loading}
              style={{ width: '100%', marginTop: '8px' }}
            >
              {loading ? 'UPDATING...' : 'UPDATE PASSWORD'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;